const config = require('../config')
config.name = 'report-app'
module.exports = config



// WEBPACK FOOTER //
// ./src/report-app/config.js